module.exports = __webpack_public_path__ + "static/media/editbnt.4779a383.svg";